import { render, staticRenderFns } from "./FlexScrollCustoms.vue?vue&type=template&id=23cc351e"
import script from "./FlexScrollCustoms.vue?vue&type=script&lang=js"
export * from "./FlexScrollCustoms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports